import axios, {AxiosPromise} from "axios";
import {HOST} from "./index";
import {Json} from "./Json";

export function Get<T>(path: string, params = {}): AxiosPromise<Json<T>> {
    return axios.get(HOST + path, params);
}

export function GetWithAuth<T>(path: string, token: any, params = {}): AxiosPromise<Json<T>> {
    return axios.get(HOST + path, {
        headers: {
            "Authorization": token
        },
        ...params
    });
}